(function(){
  function iniciar(root){
    if(!root||root.dataset.listo) return;
    root.dataset.listo='1';
    var quieto=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cab=document.querySelector('sticky-header');
    if(cab&&cab.getAttribute('data-sticky-type')==='always') root.style.setProperty('--dlp-top',cab.offsetHeight+'px');
    var $=function(s){return root.querySelector(s)}, $$=function(s){return Array.prototype.slice.call(root.querySelectorAll(s))};

    // La foto principal se asienta cuando se va el león de carga (o de inmediato si no hay león)
    var asentar=function(){requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('dlp-listo')})})};
    if(window.dlpListo||!document.querySelector('[data-leon-global]')) asentar(); else document.addEventListener('dlp:listo',asentar,{once:true});

    // Info fija: si es más alta que la pantalla, baja hasta mostrar su final y ahí se queda
    var info=root.querySelector('.dlp-info');
    function fijarInfo(){
      if(!info) return;
      var tope=parseFloat(getComputedStyle(root).getPropertyValue('--dlp-top'))||0;
      info.style.top=Math.min(tope,window.innerHeight-info.offsetHeight)+'px';
    }
    fijarInfo();
    window.addEventListener('resize',fijarInfo,{passive:true});
    if('ResizeObserver' in window&&info) new ResizeObserver(fijarInfo).observe(info);

    // Scroll suave (Lenis). Se apaga dentro de cajones y menús del tema.
    var lenis=null;
    if(!quieto && root.dataset.scroll==='true' && window.Lenis && !window.__dlpLenis){
      try{
        lenis=new Lenis({lerp:.09,smoothWheel:true,prevent:function(n){return !!(n&&n.closest&&n.closest('cart-drawer,menu-drawer,details-modal,predictive-search,.drawer,.modal,[data-lenis-prevent]'))}});
        window.__dlpLenis=lenis;
        (function raf(t){lenis.raf(t);requestAnimationFrame(raf)})(0);
        new MutationObserver(function(){
          if(/overflow-hidden/.test(document.body.className)) lenis.stop(); else lenis.start();
        }).observe(document.body,{attributes:true,attributeFilter:['class']});
      }catch(e){lenis=null}
    }
    var ir=$('[data-ir-medida]');
    if(ir) ir.addEventListener('click',function(e){
      var d=document.getElementById(ir.getAttribute('href').slice(1)); if(!d) return;
      e.preventDefault(); if(lenis) lenis.scrollTo(d,{offset:-24}); else d.scrollIntoView({behavior:quieto?'auto':'smooth'});
    });

    // Títulos que enfocan palabra por palabra
    $$('.enfoca').forEach(function(h){
      var i=0;
      (function partir(n){
        Array.prototype.slice.call(n.childNodes).forEach(function(c){
          if(c.nodeType===3){
            var f=document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function(p){
              if(!p) return;
              if(/^\s+$/.test(p)){f.appendChild(document.createTextNode(p));return}
              var s=document.createElement('span');s.className='w';s.style.setProperty('--i',i++);s.textContent=p;f.appendChild(s);
            });
            c.parentNode.replaceChild(f,c);
          }else if(c.nodeType===1){partir(c)}
        });
      })(h);
    });

    // Aparición: solo lo que está fuera del primer pantallazo
    var obs=('IntersectionObserver' in window)&&!quieto?new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('pend');obs.unobserve(e.target)}});
    },{rootMargin:'0px 0px -12% 0px'}):null;
    $$('.rev,.enfoca,.dlp-linea').forEach(function(el){
      if(obs && el.getBoundingClientRect().top>window.innerHeight){el.classList.add('pend');obs.observe(el)}
    });

    // Fotos: entran con un barrido y flotan al hacer scroll (funciona igual en celular)
    var fotos=$$('.dlp-tesela,.dlp-medio,.dlp-muerde,.dlp-marco');
    if(!quieto && 'IntersectionObserver' in window && fotos.length){
      var obsF=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('dentro');obsF.unobserve(e.target)}});
      },{rootMargin:'0px 0px -8% 0px'});
      fotos.forEach(function(f){if(f.getBoundingClientRect().top>window.innerHeight){f.classList.add('dlp-revela');obsF.observe(f)}else{f.classList.add('dlp-revela','dentro')}});
      var flotan=fotos.map(function(f){var c=f.firstElementChild;return (c&&/^(IMG|VIDEO)$/.test(c.tagName))?c:null}).filter(Boolean);
      var pendiente=false;
      var flotar=function(){
        pendiente=false;var h=window.innerHeight;
        var rs=flotan.map(function(im){return im.parentNode.getBoundingClientRect()});
        flotan.forEach(function(im,k){
          var r=rs[k];if(r.bottom<-50||r.top>h+50) return;
          var p=(r.top+r.height/2-h/2)/(h/2+r.height/2);
          im.style.translate='0 '+(Math.max(-1,Math.min(1,p))*-4).toFixed(2)+'%';
        });
      };
      window.addEventListener('scroll',function(){if(!pendiente){pendiente=true;requestAnimationFrame(flotar)}},{passive:true});
      flotar();
    }

    // Carrusel del celular: barra de avance y contador siguen al dedo
    var pista=$('[data-pista]'),barraG=$('[data-gal-barra]'),numG=$('[data-gal-n]');
    if(pista&&barraG){
      var nG=pista.children.length||1;barraG.style.width=(100/nG)+'%';
      var pendG=false;
      var moverG=function(){pendG=false;var w=pista.clientWidth||1,x=pista.scrollLeft/w;barraG.style.transform='translateX('+(x*100).toFixed(1)+'%)';if(numG) numG.textContent=Math.min(nG,Math.round(x)+1)};
      pista.addEventListener('scroll',function(){if(!pendG){pendG=true;requestAnimationFrame(moverG)}},{passive:true});
    }

    // Medidas: botones de la ficha + regla, sincronizados con la variante real
    var tallas=$$('.dlp-talla'),sels=$$('.dlp-sel');
    var inputs=$$('[data-vid-input]'),botones=$$('[data-agregar]'),precio=$('[data-precio]'),antes=$('[data-antes]');
    var txtBoton=root.dataset.boton||'Agregar a la bolsa';
    var R=tallas.map(function(b){
      var m=(b.dataset.medida||'').match(/\d+(?:\.\d+)?/g);
      if(m&&m.length>=2) return [parseFloat(m[0]),parseFloat(m[1])];
      if(m&&m.length===1) return [parseFloat(m[0]),parseFloat(m[0])];
      return null;
    });
    var nums=[];R.forEach(function(r){if(r){nums.push(r[0],r[1])}});
    var MIN=nums.length?Math.floor(Math.min.apply(null,nums))-1:13, MAX=nums.length?Math.ceil(Math.max.apply(null,nums))+1:22, X0=14, X1=606;
    function x(cm){return X0+(cm-MIN)/(MAX-MIN)*(X1-X0)}
    var marcas=$('[data-marcas]'),rango=$('[data-rango]'),cifra=$('[data-cifra]');
    if(marcas){
      var svg='';
      for(var c=MIN;c<=MAX+.001;c+=.5){
        var e=Math.abs(c%1)<.01;
        svg+='<line class="marca-r" x1="'+x(c)+'" x2="'+x(c)+'" y1="18" y2="'+(e?36:27)+'" stroke-width="1"/>';
        if(e) svg+='<text x="'+x(c)+'" y="56" text-anchor="middle">'+c+'</text>';
      }
      marcas.innerHTML=svg;
    }
    function talla(t,cambiarVariante){
      tallas.concat(sels).forEach(function(b){b.setAttribute('aria-pressed',+b.dataset.t===t?'true':'false')});
      var r=R[t];
      if(rango&&r){var ancho=Math.max(4,x(r[1])-x(r[0]));rango.setAttribute('x',(x(r[0])+x(r[1]))/2-ancho/2);rango.setAttribute('width',ancho)}
      if(cifra) cifra.innerHTML=r?((r[0]===r[1]?r[0]:r[0]+' – '+r[1])+'<small>cm</small>'):(tallas[t]?tallas[t].dataset.nombre:'&nbsp;');
      var b=tallas[t];
      if(cambiarVariante&&b&&inputs.length){
        inputs.forEach(function(i){i.value=b.dataset.vid});
        if(precio) precio.textContent=b.dataset.precio;
        if(antes){antes.textContent=b.dataset.antes;antes.hidden=!b.dataset.antes}
        var ok=b.dataset.disp==='true';
        botones.forEach(function(bt){bt.disabled=!ok;bt.removeAttribute('aria-disabled');var sp=bt.querySelector('span')||bt;sp.textContent=ok?(bt.dataset.txt||txtBoton):'Agotado'});
        try{var u=new URL(location.href);u.searchParams.set('variant',b.dataset.vid);history.replaceState(null,'',u.toString())}catch(err){}
      }
    }
    tallas.concat(sels).forEach(function(b){b.addEventListener('click',function(){talla(+b.dataset.t,true)})});
    var ini=0;tallas.forEach(function(b,j){if(b.getAttribute('aria-pressed')==='true') ini=j});
    if(tallas.length) talla(ini,false);

    // Pestañas con foto viva: una abierta a la vez, cambia la foto
    var capas=$$('[data-marco] .dlp-capa'),ds=$$('[data-viva] details');
    ds.forEach(function(d){
      d.addEventListener('toggle',function(){
        if(!d.open) return;
        ds.forEach(function(o){if(o!==d) o.open=false});
        var k=+d.dataset.c;capas.forEach(function(c,j){c.classList.toggle('activa',j===k)});
      });
    });

    // Detalle: lupa de joyero (o zoom, si así se elige) ligada al scroll
    var sec=$('[data-detalle]'),img=$('[data-lente]'),prog=$('[data-prog]'),textos=sec?sec.querySelectorAll('.dlp-texto'):[];
    var fuerza=parseFloat(root.dataset.zoom);if(isNaN(fuerza)) fuerza=1.2;
    var lente=$('.dlp-con-lupa'),lupa=$('[data-lupa]'),lupaImg=$('[data-lupa-img]');
    var puntos=[[49,54,2.4],[50,44.5,3],[50,46,1.8]];
    if(lente&&lente.dataset.puntos){
      var pp=lente.dataset.puntos.trim().split(/\s+/).map(function(t){var a=t.split(',').map(parseFloat);return [a[0],a[1],isNaN(a[2])?2.5:a[2]]}).filter(function(a){return !isNaN(a[0])&&!isNaN(a[1])});
      if(pp.length) puntos=pp;
    }
    var zMax=Math.max.apply(null,puntos.map(function(a){return a[2]})),W=0,H=0,D=0;
    function medirLupa(){if(!lente||!lupa||!lupaImg) return;W=lente.clientWidth;H=lente.clientHeight;D=lupa.offsetWidth;lupaImg.style.width=(W*zMax)+'px';lupaImg.style.height=(H*zMax)+'px'}
    function puntoEn(p){
      var n=puntos.length;if(n===1) return puntos[0];
      var c=function(k){return (k+.5)/n},k=0;while(k<n-2&&p>c(k+1)) k++;
      var t=Math.max(0,Math.min(1,(p-c(k))/(c(k+1)-c(k))));t=t*t*(3-2*t);
      var a=puntos[k],b=puntos[k+1];return [a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t];
    }
    window.addEventListener('resize',function(){W=0},{passive:true});
    function alScroll(){
      if(!sec) return;
      var r=sec.getBoundingClientRect(),total=r.height-window.innerHeight;
      var p=total>0?Math.min(1,Math.max(0,-r.top/total)):0;
      if(lente&&lupa&&lupaImg){
        if(!W) medirLupa();
        var q=quieto?puntos[0]:puntoEn(p),z=q[2],cx=q[0]/100*W,cy=q[1]/100*H;
        lupa.style.transform='translate('+(cx-D/2).toFixed(1)+'px,'+(cy-D/2).toFixed(1)+'px)';
        lupaImg.style.transform='translate('+(D/2-cx*z).toFixed(1)+'px,'+(D/2-cy*z).toFixed(1)+'px) scale('+(z/zMax).toFixed(4)+')';
        lupa.classList.toggle('ver',r.top<window.innerHeight*.6&&r.bottom>window.innerHeight*.4);
        if(!quieto&&img) img.style.transform='scale('+(1+.04*p).toFixed(3)+')';
      } else {
        var s=p<.5?p*2:1, ease=1-Math.pow(1-s,3);
        var f=window.innerWidth<900?fuerza*.5:fuerza;
        if(!quieto&&img) img.style.transform='scale('+(1+ease*f).toFixed(3)+')';
      }
      if(prog) prog.style.transform='scaleX('+p.toFixed(3)+')';
      var i=Math.min(textos.length-1,Math.floor(p*textos.length*.999));
      Array.prototype.forEach.call(textos,function(t,k){t.classList.toggle('activo',k===i)});
    }
    var pendZ=false;
    window.addEventListener('scroll',function(){if(!pendZ){pendZ=true;requestAnimationFrame(function(){pendZ=false;alScroll()})}},{passive:true});
    alScroll();
  }
  // iPhone: sin esto Safari no muestra el estado :active (el dorado al picar)
  document.addEventListener('touchstart',function(){},{passive:true});
  function todos(ctx){Array.prototype.forEach.call((ctx||document).querySelectorAll('[data-dlp]'),iniciar)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){todos()}); else todos();
  document.addEventListener('shopify:section:load',function(e){todos(e.target)});
})();
